// @flow
import React from 'react'
import Immutable from 'seamless-immutable'

// components
import { FieldLabel, Popover } from '../../Components/'
import { Radio } from '../../Components/_formFields'

// types
import type { DefaultMiniAppProps } from './'
import isMobile from 'is-mobile'

type OwnerRadioAppProps = DefaultMiniAppProps & {
  miniAppData: {
    inputHelps: Object,
    ownerRadioAppTextMode?: boolean,
  }
}

export default class OwnerRadioApp extends React.Component<OwnerRadioAppProps> {
  static defaultProps = { }

  componentDidMount() { }

  shouldComponentUpdate(nextProps: OwnerRadioAppProps) {
    return JSON.stringify(this.props.content) !== JSON.stringify(nextProps.content) ||
      this.props.formData.getIn(['userSameAsPolicyHolder']) !== nextProps.formData.getIn(['userSameAsPolicyHolder']) ||
      this.props.formData.getIn(['ownerSameAsPolicyHolder']) !== nextProps.formData.getIn(['ownerSameAsPolicyHolder']) ||
      this.props.formData.getIn(['ownerSameAsUser']) !== nextProps.formData.getIn(['ownerSameAsUser']) ||
      this.props.miniAppData && nextProps.miniAppData && (
        this.props.miniAppData.ownerRadioApp.ownerRadioAppTextMode !== nextProps.miniAppData.ownerRadioApp.ownerRadioAppTextMode ||
        JSON.stringify(this.props.miniAppData.ownerRadioApp.inputHelps) !== JSON.stringify(nextProps.miniAppData.ownerRadioApp.inputHelps)
      )
  }

  componentDidUpdate(prevProps: OwnerRadioAppProps) { }

  handleOnChange = (values: Object) => {
    const { onChangeFormData } = this.props
    onChangeFormData(new Immutable(values))
  }

  render() {
    const { formData, content, miniAppData } = this.props
    const data = miniAppData.ownerRadioApp

    if (!content.components.ownerType) {
      return null
    }

    if (data.ownerRadioAppTextMode) {
      let label = content.components.ownerType.labels.ownerNotSame
      if (formData.ownerSameAsPolicyHolder) {
        label = content.components.ownerType.labels.ownerSameAsPolicyHolder
      }
      else if (formData.ownerSameAsUser) {
        label = content.components.ownerType.labels.ownerSameAsUser
      }
      return ([
        <hr className='border-0 border-sm-top border-active-object' key='OwnerRadioApp-hr' />,
        <div className='form-group d-flex flex-row flex-wrap flex-sm-row align-items-center' key='OwnerRadioApp-content'>
          <div className='col-10 col-sm-4 order-0 order-sm-0 pt-sm-2 mt-sm-1 text-sm-right'>
            <FieldLabel
              id='OwnerRadioApp'
              isRequired
              label={content.fieldNames.ownerType}
            />
          </div>
          <div className='col-12 col-sm-6 order-3 order-sm-0 my-2'>
            <span>{label}</span>
          </div>
        </div>
      ])
    }

    return ([
      <hr className='border-0 border-sm-top border-active-object' key='OwnerRadioApp-hr' />,
      <div className='form-group d-flex flex-row flex-wrap flex-sm-row align-items-center' key='OwnerRadioApp-content'>
        <div className='col-10 col-sm-4 order-0 order-sm-0 pt-sm-2 mt-sm-1 text-sm-right'>
          <FieldLabel
            id='OwnerRadioApp'
            isRequired
            label={content.fieldNames.ownerType}
          />
        </div>
        <div className='col-12 col-sm-5 order-3 order-sm-0 mt-2 mt-sm-0 pr-sm-0'>
          <ul className='list list-in-row mb-0 child-mb-0 small-spacing w-100 pr-0'>
            <li className='py-2' key={`OwnerRadioApp-ownerSameAsPolicyHolder`}>
              <Radio
                checked={formData.ownerSameAsPolicyHolder}
                enabled
                id={`OwnerRadioApp-ownerSameAsPolicyHolder`}
                label={content.components.ownerType.labels.ownerSameAsPolicyHolder}
                name={`OwnerRadioApp-ownerSameAsPolicyHolder`}
                onChange={() => {
                  this.handleOnChange({
                    ownerSameAsPolicyHolder: true,
                    ownerSameAsUser: false,
                  })
                }}
                value='ownerSameAsPolicyHolder'
              />
            </li>
            {!formData.userSameAsPolicyHolder &&
            <li className='py-2' key={`OwnerRadioApp-ownerSameAsUser`}>
              <Radio
                checked={formData.ownerSameAsUser}
                enabled
                id={`OwnerRadioApp-ownerSameAsUser`}
                label={content.components.ownerType.labels.ownerSameAsUser}
                name={`OwnerRadioApp-ownerSameAsUser`}
                onChange={() => {
                  this.handleOnChange({
                    ownerSameAsPolicyHolder: false,
                    ownerSameAsUser: true,
                  })
                }}
                value='ownerSameAsUser'
              />
            </li>}
            <li className='py-2' key={`OwnerRadioApp-ownerNotSame`}>
              <Radio
                checked={!formData.ownerSameAsPolicyHolder && !formData.ownerSameAsUser}
                enabled
                id={`OwnerRadioApp-ownerNotSame`}
                label={content.components.ownerType.labels.ownerNotSame}
                name={`OwnerRadioApp-ownerNotSame`}
                onChange={() => {
                  this.handleOnChange({
                    ownerSameAsPolicyHolder: false,
                    ownerSameAsUser: false,
                  })
                }}
                value='ownerNotSame'
              />
            </li>
          </ul>
        </div>
        {data.inputHelps.ownerSameAsPolicyHolder &&
        <div className={`col-2 col-sm-1 order-0 order-sm-0 ${isMobile() ? 'text-right' : 'text-left'}`}>
          <Popover
            content={data.inputHelps.ownerSameAsPolicyHolder.content}
            id={`OwnerRadioApp-ownerSameAsPolicyHolder-helper`}
            title={data.inputHelps.ownerSameAsPolicyHolder.title}
          />
        </div>}
      </div>
    ])
  }
}
